import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchCategories } from "DBServices/firestoreDBService";

const Container = tw.div`relative bg-gray-900 text-gray-100 -mx-8 -mb-8 px-8`;
const Content = tw.div`max-w-screen-xl mx-auto pt-16 pb-8`;
const FiveColumns = tw.div`flex flex-wrap justify-between`;

const Column = tw.div`w-1/2 md:w-1/5 mb-8 md:mb-0 text-sm sm:text-base text-center md:text-left`;
const CompanyColumn = tw.div`text-center md:text-left mb-16 lg:mb-0 w-full lg:w-1/5`;

const ColumnHeading = tw.h5`font-bold uppercase`;

const LinkList = tw.ul`mt-4 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = styled.a`
  ${tw`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-100 pb-1 transition duration-300 cursor-pointer`}
`;

const LogoContainer = tw.div`flex items-center justify-center lg:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black`;

const CompanyAddress = tw.p`mt-4 max-w-xs font-medium text-sm mx-auto lg:mx-0 lg:mr-4 leading-loose text-center lg:text-left`;

const SocialLinksContainer = tw.div`mt-4 text-center lg:text-left`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-500 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

const CopyrightAndCompanyInfoRow = tw.div`pb-0 text-sm font-normal flex flex-col sm:flex-row justify-between items-center`;
const CopyrightNotice = tw.div``;
const CompanyInfo = tw.div``;
const Divider = tw.div`my-8 border-b-2 border-gray-800`;

const FooterComponent = (props) => {
  const history = useHistory();
  const [liveCategories, setLiveCategories] = useState([]);

  const LogoImage = props.FooterData.LogoImage;
  const LogoTextData = props.FooterData.LogoText;
  const CompanyAddressData = props.FooterData.CompanyAddressData;
  const SocialLinkContainerData = props.FooterData.SocialLink;
  const ColumnHeadingData1 = props.FooterData.ColumnHeading1;
  const ColumnHeadingData3 = props.FooterData.ColumnHeading3;
  const ColumnHeadingData4 = props.FooterData.ColumnHeading4;
  const LinkListItemData1 = props.FooterData.LinkListItem1;
  const LinkListItemData3 = props.FooterData.LinkListItem3;
  const LinkListItemData4 = props.FooterData.LinkListItem4;
  const CopyrightData = props.FooterData.CopyrightData;
  const CompanyInfoData = props.FooterData.CompanyInfoData;

  // Fetch real categories from Firestore
  useEffect(() => {
    fetchCategories()
      .then((cats) => {
        if (cats && cats.length > 0) {
          setLiveCategories(cats);
        }
      })
      .catch(() => {
        // silently fail — fallback to static list
        setLiveCategories(props.FooterData.LinkListItem2 || []);
      });
  }, []);

  const handleNavClick = (e, href) => {
    if (!href || href === '#') { e.preventDefault(); return; }
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return;
    e.preventDefault();
    history.push(href);
  };

  // Build category links from live Firestore data, or fall back to static store data
  const categoryLinks = liveCategories.length > 0
    ? liveCategories.map((cat) => ({
        innerHtml: cat.name || cat.title || cat.category || 'Category',
        href: `/marketplace?page=stock&tab=Foods&q=${encodeURIComponent(cat.name || cat.title || '')}`
      }))
    : (props.FooterData.LinkListItem2 || []);

  return (
    <Container>
      <Content>
        <FiveColumns>
          <CompanyColumn>
            <LogoContainer>
              <LogoImg src={LogoImage} />
              <LogoText>{LogoTextData}</LogoText>
            </LogoContainer>
            <CompanyAddress>
              {CompanyAddressData}
            </CompanyAddress>
            <SocialLinksContainer>
              {SocialLinkContainerData.map((LinkData, i) => (
                <SocialLink key={i} href={LinkData.href} target="_blank" rel="noopener noreferrer">
                  {LinkData.Icon}
                </SocialLink>
              ))}
            </SocialLinksContainer>
          </CompanyColumn>

          <Column>
            <ColumnHeading>{ColumnHeadingData1}</ColumnHeading>
            <LinkList>
              {LinkListItemData1.map((ListItem, index) => (
                <LinkListItem key={index}>
                  <Link href={ListItem.href} onClick={(e) => handleNavClick(e, ListItem.href)}>
                    {ListItem.innerHtml}
                  </Link>
                </LinkListItem>
              ))}
            </LinkList>
          </Column>

          <Column>
            <ColumnHeading>Categories</ColumnHeading>
            <LinkList>
              {categoryLinks.map((ListItem, index) => (
                <LinkListItem key={index}>
                  <Link href={ListItem.href} onClick={(e) => handleNavClick(e, ListItem.href)}>
                    {ListItem.innerHtml}
                  </Link>
                </LinkListItem>
              ))}
            </LinkList>
          </Column>

          <Column>
            <ColumnHeading>{ColumnHeadingData3}</ColumnHeading>
            <LinkList>
              {LinkListItemData3.map((ListItem, index) => (
                <LinkListItem key={index}>
                  <Link href={ListItem.href} onClick={(e) => handleNavClick(e, ListItem.href)}>
                    {ListItem.innerHtml}
                  </Link>
                </LinkListItem>
              ))}
            </LinkList>
          </Column>

          {ColumnHeadingData4 && (
            <Column>
              <ColumnHeading>{ColumnHeadingData4}</ColumnHeading>
              <LinkList>
                {LinkListItemData4.map((ListItem, index) => (
                  <LinkListItem key={index}>
                    <Link href={ListItem.href} onClick={(e) => handleNavClick(e, ListItem.href)}>
                      {ListItem.innerHtml}
                    </Link>
                  </LinkListItem>
                ))}
              </LinkList>
            </Column>
          )}
        </FiveColumns>
        <Divider />
        <CopyrightAndCompanyInfoRow>
          <CopyrightNotice>&copy; {CopyrightData}</CopyrightNotice>
          <CompanyInfo>{CompanyInfoData}</CompanyInfo>
        </CopyrightAndCompanyInfoRow>
      </Content>
    </Container>
  );
};

const Footer = connect((state) => ({
  FooterData: state.FooterData
}))(FooterComponent);

export default Footer;